module.exports = __webpack_public_path__ + "static/media/TasklyPaperPrototypes.9aa0ace8.png";